import { apiClient } from '@/shared/api';
import {
  PermissionListResponse,
  RoleCreateRequest,
  RoleCreateResponse,
  RoleDeleteResponse,
  RoleListResponse,
  RoleResponse,
  RoleUpdateRequest,
} from './types';

// POST /role - create a new role
export const createRole = async (payload: RoleCreateRequest) => {
  const { data } = await apiClient.post<RoleCreateResponse>('/role', payload);
  return data;
};

// GET /role - list roles with optional filters
export const fetchRoles = async (params?: { isDeleted?: boolean | null }) => {
  const { data } = await apiClient.get<RoleListResponse>('/role', { params });
  return data;
};

// PUT /role/{code} - update role
export const updateRole = async ({ code, body }: { code: string; body: RoleUpdateRequest }) => {
  const { data } = await apiClient.put<RoleResponse>(`/role/${code}`, body);
  return data;
};

// DELETE /role/{code} - soft delete role
export const deleteRole = async (code: string) => {
  const { data } = await apiClient.delete<RoleDeleteResponse>(`/role/${code}`);
  return data;
};

// GET /permission - list all permissions
export const fetchPermissions = async () => {
  const { data } = await apiClient.get<PermissionListResponse>('/permission');
  return data;
};
